import React, { Component } from 'react'
import { Modal, Form, Input, Checkbox, DatePicker, Select } from 'antd'
import moment from 'moment'
import _ from 'lodash'

const { RangePicker } = DatePicker

class storageEditModal extends Component {
  state={
    isFetching: false
  }

  handleOk = (e) => {
    e.preventDefault()

    const {
      updateProperties,
      addTags,
      replaceStorageFileById,
      asset,
      form: { validateFields }
    } = this.props

    this.setState({
      isFetching: true
    })

    validateFields((err, values) => {
      if (!err) {
        let properties = {
          timestampAccessStart: null,
          timestampAccessEnd: null,
          shareable: values.shareable,
          downloadable: values.downloadable
        }

        if (values.dates && values.dates.length) {
          properties = {
            ...properties,
            timestampAccessStart: values.dates[0].toISOString(),
            timestampAccessEnd: values.dates[1].toISOString()
          }
        }

        const guid = asset.guid
        let promises = []

        const assetPropertiesToFormat = {
          timestampAccessStart: asset.properties.timestampAccessStart ? moment(asset.properties.timestampAccessStart).toISOString() : null,
          timestampAccessEnd: asset.properties.timestampAccessEnd ? moment(asset.properties.timestampAccessEnd).toISOString() : null,
          shareable: asset.properties.shareable,
          downloadable: asset.properties.downloadable
        }

        const assetTagsToFormat = asset.tags.map(tag => tag.id.toString())

        const isEqualProperties = _.isEqual(assetPropertiesToFormat, properties)
        const isEqualTags = _.isEqual(assetTagsToFormat, values.tags)

        if (!isEqualProperties) {
          promises.push(updateProperties(guid, properties))
        }

        if (!isEqualTags) {
          promises.push(addTags(guid, values.tags))
        }

        Promise.all(promises)
          .then((response) => {
            return replaceStorageFileById(guid, {
              name: values.name
            })
          })
          .then(() => {
            this.setState({
              isFetching: false
            })

            this.handleCancel()
          })
      } else {
        this.setState({
          isFetching: false
        })
      }
    })
  }

  handleCancel = (e) => {
    const { closeModal, setTable } = this.props
    closeModal()
    setTable([], [])
  }

  render () {
    const {
      status,
      asset,
      tags,
      form: { getFieldDecorator }
    } = this.props

    const { isFetching } = this.state

    const layout = {
      labelCol: {
        md: { span: 10 }
      },
      wrapperCol: {
        md: { span: 14 }
      }
    }

    const timestampAccessStart = asset.properties.timestampAccessStart ? moment(asset.properties.timestampAccessStart) : null
    const timestampAccessEnd = asset.properties.timestampAccessEnd ? moment(asset.properties.timestampAccessEnd) : null
    const isDates = timestampAccessStart && timestampAccessEnd

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Edit asset information'
        visible={status}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText={'Update'}
        okType='indigo'
        okButtonProps={{ loading: isFetching }}
        destroyOnClose
        width={650}
      >
        <Form onSubmit={this.handleOk} className='form'>
          <Form.Item {...layout} label='Name'>
            {getFieldDecorator('name', {
              rules: [{ required: true,
                message: 'Please input asset name',
                max: 320,
                pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
              }],
              initialValue: asset.name
            })(
              <Input name='name' maxLength={320} addonAfter={asset.extension} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='Asset permissions'>
            {getFieldDecorator('shareable', {
              valuePropName: 'checked',
              initialValue: asset.properties.shareable
            })(<Checkbox>Can be shared</Checkbox>)}
          </Form.Item>

          <Form.Item {...layout} label='&nbsp;'>
            {getFieldDecorator('downloadable', {
              valuePropName: 'checked',
              initialValue: asset.properties.downloadable
            })(
              <Checkbox>Can be downloaded</Checkbox>
            )}
          </Form.Item>

          <Form.Item {...layout} label='Time sensitive content'>
            {getFieldDecorator('dates', {
              rules: [{
                type: 'array',
                // required: true,
                message: 'Please select dates'
              }],
              initialValue: isDates ? [timestampAccessStart, timestampAccessEnd] : null
            })(
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format='YYYY-MM-DD HH:mm'
              />
            )}
          </Form.Item>

          <Form.Item {...layout} label='Tags'>
            {getFieldDecorator('tags', {
              initialValue: asset.tags.map(tag => tag.id.toString()),
              rules: [{
                type: 'array'
              }]
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>

        </Form>
      </Modal>
    )
  }
}

export default Form.create()(storageEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageEditModal/StorageEditModal.jsx